export default __webpack_public_path__ + "static/media/noContent.b37a5498.svg";